var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "CompassDialog",
    {
      staticClass: "card-setting-overlay",
      attrs: {
        visible: _vm.showModal,
        size: "small",
        title:
          _vm.$t.__("dashboard.CardSettingOverlay.title") +
          _vm.cardCustomSettings.title
      },
      on: {
        "update:visible": function($event) {
          _vm.showModal = $event
        },
        "before-close": _vm.close,
        closed: _vm.close
      },
      scopedSlots: _vm._u([
        {
          key: "default",
          fn: function() {
            return [
              _c(
                "div",
                { staticClass: "dialog__default" },
                [
                  _c("p", [
                    _vm._v(
                      "\n                " +
                        _vm._s(
                          _vm.$l10n.__(
                            "Définissez les informations à afficher sur la carte pour personnaliser votre tableau de bord selon vos besoins."
                          )
                        ) +
                        "\n            "
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-form",
                    {
                      ref: "formOverlay",
                      attrs: {
                        model: _vm.form,
                        rules: _vm.titleRules,
                        validateOnRuleChange: false,
                        labelPosition: "top"
                      }
                    },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "mb-2",
                          attrs: {
                            prop: "title",
                            label: _vm.$t.__(
                              "dashboard.CardSettingOverlay.card_name"
                            )
                          }
                        },
                        [
                          _c("el-input", {
                            staticClass: "wp-3",
                            attrs: {
                              type: "text",
                              rows: "1",
                              maxlength: _vm.titleMaxLength
                            },
                            on: { change: _vm.formatTitle },
                            model: {
                              value: _vm.form.title,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "title", $$v)
                              },
                              expression: "form.title"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(_vm.formName, {
                        tag: "component",
                        attrs: {
                          form: _vm.form,
                          cardCustomSettings: _vm.cardCustomSettings,
                          cardName: _vm.cardName,
                          cardSettings: _vm.cardSettings,
                          loading: _vm.loading
                        },
                        on: {
                          "close-form": _vm.close,
                          "save-settings": _vm.save,
                          "set-rules": _vm.init,
                          updateLoading: _vm.setLoading
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ]
          },
          proxy: true
        }
      ])
    },
    [_c("preloader", { attrs: { display: _vm.loading } })],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }